export default __webpack_public_path__ + "static/media/Master-Shyft-Logo.8d62a15c.svg";